import React from 'react';

import BottomPopup from '@Components/core/bottom-popup';
import Button from '@Components/design-system/button-v2';
import Text from '@Components/design-system/text-v2';

import { PaletteType, TextPalette } from '../color-v2/types';
import { FontType } from '../text-v2/types';

export interface ConfirmActionProps {
  confirm: {
    label: string;
    onClick?: (e?: React.MouseEvent<HTMLButtonElement>) => void;
  };
  cancel: {
    label: string;
    onClick?: (e?: React.MouseEvent<HTMLButtonElement>) => void;
  };
  title: string;
  description: string | React.ReactNode;
}

const ConfirmAction = ({ confirm, cancel, title, description }: ConfirmActionProps) => {
  return (
    <BottomPopup handleCloseFrame={cancel.onClick} width={'720px'}>
      <div className='p-4 pb-8 flex flex-col gap-2'>
        <Text font={FontType.H4_B} color={TextPalette.DARK_1}>
          {title}
        </Text>
        <Text font={FontType.BODY_L} color={TextPalette.DARK_2}>
          {description}
        </Text>
      </div>
      <div className='grid grid-cols-2 gap-2 p-4'>
        <Button
          onClick={confirm.onClick}
          view='text'
          size='large'
          variant='secondary'
          fullWidth
          text={confirm.label}
          textColor={PaletteType.WARNING_600}
        />
        <Button onClick={cancel.onClick} view='text' variant='primary' size='large' text={cancel.label} fullWidth />
      </div>
    </BottomPopup>
  );
};

export default ConfirmAction;
